module.exports = __webpack_public_path__ + "img/peppi-1.1420e7ce.png";